import {
  IClinicInfo,
  IClinicImage,
  ITreatment,
  IDoctor,
} from "../types/clinic.types";

export const MOCK_IMAGES: IClinicImage[] = [
  {
    id: "img1",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*mrKawyepnNmoK8UTm0IIsw.png?text=Clinic+Front",
    alt: "Clinic Front",
  },
  {
    id: "img2",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*mrKawyepnNmoK8UTm0IIsw.png?text=Lobby",
    alt: "Lobby",
  },
  {
    id: "img3",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*mrKawyepnNmoK8UTm0IIsw.png?text=Exam+Room",
    alt: "Exam Room",
  },
];

export const MOCK_INFO: IClinicInfo = {
  name: "Central Clinic",
  slug: "Central_Clinic",
  description: "Your trusted partner in advanced healthcare.",
  addressLine: "123 Health St, Wellness City",
  street: "123 Health St, Wellness City",
  district: "Ratnapura",
  city: "Balangoda",
  map: "Balangoda",
  email: "contact@centralclinic.com",
  openingHours: [
    { day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false },
    { day: "Tuesday", openTime: "09:00", closeTime: "17:00", isClosed: false },
    {
      day: "Wednesday",
      openTime: "09:00",
      closeTime: "17:00",
      isClosed: false,
    },
    { day: "Thursday", openTime: "09:00", closeTime: "19:00", isClosed: false },
    { day: "Friday", openTime: "09:00", closeTime: "17:00", isClosed: false },
    { day: "Saturday", openTime: "10:00", closeTime: "14:00", isClosed: false },
    { day: "Sunday", openTime: "00:00", closeTime: "00:00", isClosed: true },
  ],
};

export const MOCK_ABOUT = `
  <h2>Welcome to Central Clinic</h2>
  <p>We are dedicated to providing <strong>top-quality healthcare</strong> for you and your family.</p>
  <ul>
    <li>State-of-the-art facilities</li>
    <li>Experienced medical professionals</li>
    <li>Patient-centered care</li>
  </ul>
`;

export const MOCK_TREATMENTS: ITreatment[] = [
  {
    id: "t1",
    name: "General Check-up",
    description: "Comprehensive health check.",
    foreginPrice: 50,
    localPrice: 100,
    subTreatments: [
      {
        id: "st1",
        subTreatment: "Blood Test",
        description: "Blood Test",
        localPrice: 30,
        duration: 45,
        foreignerPrice: 45,
        minlocalPrice: 45,
        minforeignerPrice: 45,
        maxlocalPrice: 45,
        maxforeignerPrice: 45,
        note: 45,
      },
    ],
  },
  {
    id: "t2",
    name: "Dentistry",
    description: "Full-service dental care.",
    foreginPrice: 75,
    localPrice: 200,
    subTreatments: [
      {
        id: "st1",
        subTreatment: "Blood Test",
        description: "Blood Test",
        localPrice: 30,
        duration: 45,
        foreignerPrice: 45,
        minlocalPrice: 45,
        minforeignerPrice: 45,
        maxlocalPrice: 45,
        maxforeignerPrice: 45,
        note: 45,
      },
      {
        id: "st1",
        subTreatment: "Blood Test",
        description: "Blood Test",
        localPrice: 30,
        duration: 45,
        foreignerPrice: 45,
        minlocalPrice: 45,
        minforeignerPrice: 45,
        maxlocalPrice: 45,
        maxforeignerPrice: 45,
        note: 45,
      },
    ],
  },
];

export const MOCK_DOCTORS: IDoctor[] = [
  {
    id: "d1",
    image:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*mrKawyepnNmoK8UTm0IIsw.png?text=Dr.+Smith",
    fullName: "Dr. Anna Smith",
    studies: ["MD, Harvard University"],
    speciality: "Cardiology",
    languages: ["English", "Spanish"],
    assignedTreatmentIds: ["t1"],
  },
  {
    id: "d2",
    image:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*mrKawyepnNmoK8UTm0IIsw.png?text=Dr.+Chen",
    fullName: "Dr. James Chen",
    studies: ["DDS, University of Pennsylvania"],
    speciality: "Dentist",
    languages: ["English", "Mandarin"],
    assignedTreatmentIds: ["t2"],
  },
];
